import { getEnv } from "#app/lib/env";

export type MobilePlatform = "ios" | "android";

export function detectMobilePlatform(
  userAgent: string,
  maxTouchPoints: number,
): MobilePlatform | null {
  if (/android/i.test(userAgent)) return "android";
  if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
  // iPadOS reports a desktop Safari user agent; the touch points give it away.
  if (/macintosh/i.test(userAgent) && maxTouchPoints > 1) return "ios";
  return null;
}

export function mobileAppUrl(platform: MobilePlatform): string {
  return platform === "ios"
    ? getEnv(
        "EXPO_PUBLIC_IOS_APP_URL",
        "https://apps.apple.com/us/app/salestrak-leads/id6784544687",
      )
    : getEnv(
        "EXPO_PUBLIC_ANDROID_APP_URL",
        "https://play.google.com/store/apps/details?id=io.salestrak.app",
      );
}
